// @ts-nocheck
import {ConfEnv} from "../../../config/config";
import privateRequest from "../../../Infra/http/private.request";

export const startBingoGameService = async (currency: string) => {
  return privateRequest.post(`${ConfEnv.BASE_URL}/bingo/start-game?currency=${encodeURIComponent(currency)}`);
};
